
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 112.405 122.441"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"b","x1":".053","y1":".5","x2":"1","y2":".5","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#fff"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#fff","stop-opacity":"0"}})]),_c('filter',{attrs:{"id":"a","x":"0","y":"0","width":"112.405","height":"122.441","filterUnits":"userSpaceOnUse"}},[_c('feOffset'),_c('feGaussianBlur',{attrs:{"stdDeviation":"10","result":"blur"}}),_c('feFlood',{attrs:{"flood-color":"#fff"}}),_c('feComposite',{attrs:{"operator":"in","in2":"blur"}}),_c('feComposite',{attrs:{"in":"SourceGraphic"}})])]),_c('g',{attrs:{"filter":"url(#a)"}},[_c('path',{attrs:{"data-name":"Path 1120","d":"M.683.024c35.787 0 61.758 12.031 61.758 25.819S35.787 52.405 0 52.405a87.229 87.229 0 004.622-26.562C4.622 13.5 1.109-.662.683.024z","transform":"rotate(90 26.205 56.205)","fill":"url(#b)"}})])])
          )
        }
      }
    